import React from 'react';
//import ReactDOM from "react-dom";

export default class Loader extends React.Component {

    render() {
        return (
            <div>
                <div id='loading'>
                </div>
                {'Please wait...'}
            </div>
        );
    }

}